import { axiosWithAuth } from '../../utilities';
import { getRequestHeaders } from '../../utilities/requestHeaders';

const options = {
  timeout: 5000
};

type UpdatePasswordBody = {
  currentPassword: string;
  newPassword: string;
};

export default class UserAccountApi {
  static updatePassword(updatePasswordBody: UpdatePasswordBody) {
    const headers = getRequestHeaders();
    const endpoint = `/v2/change-password`;
    return axiosWithAuth().post(endpoint, updatePasswordBody, {
      ...options,
      headers,
      timeout: 25000
    });
  }
}
